// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';//解决ie浏览器不支持promise
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/';

import $ from 'jquery';
import bootstrap from 'bootstrap-vue';
import 'jquery/dist/jquery.min';
import 'bootstrap/dist/js/bootstrap.min';
import './config/resize';
import Element from './components/element/index';
import tool from './config/tool';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/dist/css/swiper.min.css';
import './style/iconfont/iconfont.css';
import './style/common.scss';


if(window.__VUE_DEVTOOLS_GLOBAL_HOOK__){
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;
}

Vue.config.productionTip = false;
Vue.use(Element);
Vue.use(tool);

/*
// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})
*/

//Vue.use($);
Vue.use(bootstrap);

new Vue({
  //el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js